var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModifyPackageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "121px",
    height: "110px",
    viewBox: "0 0 121 110",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iconmonstr-video-6 copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Latest-Version",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconmonstr-video-6-copy",
    fill: "#C3C3C3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.7065678,65 C85.2652648,65 75.1588983,75.075 75.1588983,87.5 C75.1588983,99.925 85.2652648,110 97.7065678,110 C110.147871,110 120.254237,99.925 120.254237,87.5 C120.254237,75.075 110.147871,65 97.7065678,65 Z M110.233051,90 L100.211864,90 L100.211864,100 L95.2012712,100 L95.2012712,90 L85.1800847,90 L85.1800847,85 L95.2012712,85 L95.2012712,75 L100.211864,75 L100.211864,85 L110.233051,85 L110.233051,90 Z M67.6530297,100 L30.0635593,100 L30.0635593,60 L80.1694915,60 L80.1694915,60.16 C89.549322,54.145 100.778061,53.565 110.233051,57.51 L110.233051,0 L0,0 L0,110 L74.2569915,110 C71.4861335,107.12 69.2163347,103.745 67.6530297,100 Z M90.190678,10 L100.211864,10 L100.211864,20 L90.190678,20 L90.190678,10 Z M90.190678,30 L100.211864,30 L100.211864,40 L90.190678,40 L90.190678,30 Z M30.0635593,10 L80.1694915,10 L80.1694915,50 L30.0635593,50 L30.0635593,10 Z M20.0423729,100 L10.0211864,100 L10.0211864,90 L20.0423729,90 L20.0423729,100 Z M20.0423729,80 L10.0211864,80 L10.0211864,70 L20.0423729,70 L20.0423729,80 Z M20.0423729,60 L10.0211864,60 L10.0211864,50 L20.0423729,50 L20.0423729,60 Z M20.0423729,40 L10.0211864,40 L10.0211864,30 L20.0423729,30 L20.0423729,40 Z M20.0423729,20 L10.0211864,20 L10.0211864,10 L20.0423729,10 L20.0423729,20 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifyPackageIcon);
export default __webpack_public_path__ + "static/media/modify-package-icon.29d7b192caae48938294b147a3513b5e.svg";
export { ForwardRef as ReactComponent };